'use strict';

import React from 'react';
import Debug from 'debug';
var debug = Debug('itaigi:無例句');

export default class 無例句 extends React.Component {

  render() {
    return (
      <div className='ui item'>
        <p>無例句</p>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/GuanKiann/例句/無例句.jsx